import { Timer } from "lucide-react";

import { formatarDuracao } from "./formatarDuracao";

/**
 * Faixa fina com o tempo médio de hoje de uma etapa. `rodape` inverte a borda
 * para ficar no pé da coluna. Rótulo e valor ficam à esquerda de propósito: o
 * resumo do dia fica no canto direito da tela.
 */
export default function MetricaTempoColuna({ rotulo, etapa, rodape = false, className = "" }) {
  const { media_seg: media, pedidos } = etapa || {};
  const dica = pedidos
    ? `Média de hoje em ${pedidos} ${pedidos === 1 ? "pedido" : "pedidos"}`
    : "Nenhum pedido de hoje passou por esta etapa ainda";
  return (
    <div
      className={`shrink-0 px-2 sm:px-3 py-1 flex items-center gap-1.5 text-[10px] sm:text-[11px] bg-muted/20 ${rodape ? "border-t" : "border-b"} ${className}`}
      title={dica}
    >
      <Timer className="w-3 h-3 text-muted-foreground shrink-0" />
      <span className="uppercase tracking-wide font-medium text-muted-foreground truncate">{rotulo}</span>
      <span className="font-bold tabular-nums text-foreground shrink-0">{formatarDuracao(media)}</span>
    </div>
  );
}
